import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@/core/auth/AuthContext';
import { notificationsService } from '../services/notifications.service';
import { toast } from 'sonner';

export function useNotifications() {
  const { profile } = useAuth();
  const userId = profile?.id || '';
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: ['settings1', 'notifications', userId],
    queryFn: () => notificationsService.getSettings(userId),
    enabled: !!userId,
  });

  const updateMutation = useMutation({
    mutationFn: ({ categoryId, channels }: { categoryId: string; channels: any }) => 
      notificationsService.updateCategory(userId, categoryId, channels),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['settings1', 'notifications'] });
      toast.success('Đã cập nhật tùy chọn thông báo');
    },
  });

  return {
    categories: query.data || [],
    isLoading: query.isLoading,
    updateCategory: updateMutation.mutate,
  };
}
